/**
 * Arked Coffee - Custom Product Page Image Switching
 * 
 * Image order per coffee product (House, Guest, Unarked):
 *   Grid index 0: tile (HOUSE/GUEST/UNARKED) - primary on catalog, always hidden on product page
 *   Grid index 1: 250g bag
 *   Grid index 2: 1kg bag
 * 
 * Behavior on product page:
 *   - 250g selected: show only 250g bag (index 1), hide tile (0) and 1kg bag (2)
 *   - 1kg selected: show only 1kg bag (index 2), hide tile (0) and 250g bag (1)
 *   - Tile (index 0) always hidden on product page
 */

(function () {
  'use strict';

  function isArkedCoffeePage() {
    return !!document.querySelector('input[type="radio"][name*="Size-"]');
  }

  function getSelectedSize() {
    const checked = document.querySelector('input[type="radio"][name*="Size-"]:checked');
    if (!checked) return '250g';
    const v = checked.value.toLowerCase().trim();
    if (v === '1kg') return '1kg';
    return '250g';
  }

  function applyImageLogic() {
    const grid = document.querySelector('.media-gallery__grid');
    if (!grid || grid.children.length < 3) return;

    const items = Array.from(grid.children);
    const size = getSelectedSize();

    // Index 0 = tile (always hidden)
    // Index 1 = 250g bag
    // Index 2 = 1kg bag
    if (size === '250g') {
      items[0].style.setProperty('display', 'none', 'important');
      items[1].style.setProperty('display', '', 'important');
      items[2].style.setProperty('display', 'none', 'important');
    } else {
      items[0].style.setProperty('display', 'none', 'important');
      items[1].style.setProperty('display', 'none', 'important');
      items[2].style.setProperty('display', '', 'important');
    }
  }

  var observerActive = false;
  var debounceTimer = null;

  function startObserver() {
    if (observerActive) return;
    const mainSection = document.querySelector('[id*="__main"]');
    if (!mainSection) return;

    observerActive = true;
    const observer = new MutationObserver(function (mutations) {
      const hasStructuralChange = mutations.some(function (m) {
        return m.type === 'childList' && m.addedNodes.length > 0;
      });
      if (!hasStructuralChange) return;

      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        applyImageLogic();
      }, 150);
    });
    observer.observe(mainSection, { childList: true, subtree: true });
  }

  function init() {
    if (!isArkedCoffeePage()) return;

    applyImageLogic();
    startObserver();

    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('input[type="radio"][name*="Size-"]')) {
        applyImageLogic();
        setTimeout(applyImageLogic, 200);
        setTimeout(applyImageLogic, 500);
        setTimeout(applyImageLogic, 1000);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 100);
  }

})();
